import { PluginDescriptor } from '../../types/PluginInterfaces';
import { VirtualRoomPainterPlugin } from './VirtualRoomPainterPlugin';
import VirtualRoomPainterSidebar from './VirtualRoomPainterSidebar';
import { VirtualRoomPropertiesPanel } from './components/VirtualRoomPropertiesPanel';
import React from 'react';
import { Home as HomeIcon } from '@mui/icons-material';

// Services
export { VirtualRoomStorage, type VirtualRoom } from './services/VirtualRoomStorage';
export { RoomOutlineService } from './services/RoomOutlineService';
export type { RoomBoundary, RoomOutlineData } from './services/RoomOutlineService';
export { databaseBridge } from './services/DatabaseBridge';
export { virtualRoomService } from '../../../../../services/back4app/VirtualRoomService';
export { virtualRoomTileService } from '../../../../../services/back4app/VirtualRoomTileService';
export { tileSyncManager } from './services/TileSyncManager';

// Hooks
export { useVirtualRoomManager } from './hooks/useVirtualRoomManager';

// Components
export * from './components';

export const virtualRoomPainterDescriptor: PluginDescriptor = {
  // Metadata
  id: 'virtual-room-painter',
  name: 'Virtual Room Painter',
  description: 'Advanced room painting tool with virtual area management',
  version: '1.0.0',
  author: 'MapEditor Team',
  category: 'painting' as any,
  icon: React.createElement(HomeIcon),
  enabledByDefault: true,
  showInToolbar: true,
  toolbarOrder: 5,

  // Factory function to create plugin instance
  createPlugin: (context) => new VirtualRoomPainterPlugin(),

  // React components
  components: {
    // ToolbarComponent: VirtualRoomPainterToolbar,
    SidebarComponent: VirtualRoomPainterSidebar,
    PropertiesComponent: VirtualRoomPropertiesPanel,
    // SettingsComponent: VirtualRoomPainterSettings
  }
};

export default virtualRoomPainterDescriptor; 